import React from "react";
import { useSelector } from "react-redux";
import { Button } from "@mui/material";

import { getButtonBgColor, getFontFamily, getIsMaximized } from "slices";
import { Icon } from "components";
import { hexToRgba } from "utils/methods/index";

const ButtonComp = ({
  icon,
  label,
  onClick,
  className = "",
  disabled,
  rounded = true,
  selected = false,
  filled = false,
  isLeftIcon = true,
  border = true,
  testId = "",
  highlightSelected = false,
}) => {
  const color = useSelector(getButtonBgColor);
  const fontFamily = useSelector(getFontFamily);
  const isMaximized = useSelector(getIsMaximized);
  const shouldHighlight = selected && !filled && highlightSelected;
  const selectedBgColor = hexToRgba(color, 0.08);

  const selectedHighlightStyles = shouldHighlight
    ? {
        backgroundColor: `${selectedBgColor} !important`,
        borderColor: `${color} !important`,
        color: "#333333 !important",
      }
    : {};

  const selectionClasses = shouldHighlight
    ? ""
    : selected
    ? " selected-active-button hayley-border-black hayley-text-black"
    : "unselected-inactive-button hayley-border-custom-4 hayley-text-secondary";

  return (
    <Button
      data-testid={testId}
      className={`hayley-button hayley-m-0 hayley-flex hayley-items-center hayley-space-x-2 hayley-bg-white !hayley-p-0 !hayley-text-xs hayley-normal-case ${
        rounded ? "hayley-rounded-full" : "hayley-rounded-none"
      } ${selectionClasses} ${filled ? "!hayley-px-5 !hayley-py-[10px]" : "!hayley-px-3 !hayley-py-[7px]"} ${isMaximized && "!hayley-px-4 !hayley-py-2"} ${
        border ? "hayley-border hayley-border-solid" : "hayley-border-none hover:!hayley-bg-transparent hover:!hayley-text-secondary"
      } ${className}`}
      sx={
        filled
          ? {
              backgroundColor: `${color} !important`,
              fontFamily: `${fontFamily} !important`,
              color: "#fff !important",
              borderColor: `${color} !important`,
              opacity: disabled ? 0.5 : 1,
            }
          : {
              "&.hayley-button": {
                fontFamily: `${fontFamily} !important`,
                backgroundColor: "#FFF",
                ...selectedHighlightStyles,
                "&:hover": { backgroundColor: `${color} !important`, borderColor: `${color} !important`, color: "#fff !important" },
              },
            }
      }
      onClick={onClick}
      disabled={disabled}
    >
      {icon && isLeftIcon && <Icon iconType={icon} className="hayley-h-5 hayley-w-5 hayley-text-inherit" />}
      <span className={`hayley-text-sm ${shouldHighlight || selected ? "hayley-font-semibold" : "hayley-font-medium"} hayley-text-inherit`}>{label}</span>
      {icon && !isLeftIcon && <Icon iconType={icon} className="hayley-h-5 hayley-w-5 hayley-text-inherit" />}
    </Button>
  );
};

export default ButtonComp;
